import React, { useState } from "react";
import { useTranslation } from "../i18n";
import AuthLanguageDropdown from "../Components/AuthLanguageDropdown";
import AuthLeftColumn from "../Components/AuthLeftColumn";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { vendorLoginAction } from "../actions/auth";
import { isValidEmailAddress } from "../utils/formValidation";

const Login = () => {
  const { t, text } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { vendorAuthLoading, vendorAuthError } = useSelector(
    (state) => state.auth,
  );

  const [showPassword, setShowPassword] = useState(false);

  const [rememberMe, setRememberMe] = useState(false);

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const canSubmitLogin =
    isValidEmailAddress(form.email) &&
    form.password.trim().length > 0 &&
    !vendorAuthLoading;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    const response = await dispatch(
      vendorLoginAction({
        username: form.email,
        password: form.password,
      }),
    );
    if (response?.status >= 200 && response?.status < 300)
      navigate("/dashboard");
  };

  const handleMicrosoftLogin = () => console.log("Microsoft login clicked");
  const handleGoogleLogin = () => {
    console.log("Google login clicked");
  };

  const handleSignup = () => {
    navigate("/signup");
  };

  const handleForgotPassword = () => {
    navigate("/forgot-password");
  };

  return (
    <main className="admin-login-page admin-login-page--reference admin-login-page--auth-shared">
      <div className="container-fluid p-0">
        <div className="row g-0 admin-login-card">
          <AuthLeftColumn />
          <div className="col-md-6 col-12 admin-login-right">
            <div className="admin-login-right-inner">
              <div className="admin-login-mobile-logo d-md-none">
                <img src="/assets/lualilogoblack.svg" alt={t("ui.luali.commodities")} />
                <AuthLanguageDropdown />
              </div>
              <div className="admin-login-form-content">
                <div className="admin-login-heading">
                  <h1>{t("ui.welcome.back.oat")}</h1>
                  <p>{text("Sign in to your Luali Commodities vendor account and continue your global trade journey.")}</p>
                </div>
                <form className="admin-login-form" onSubmit={handleSubmit}>
                  <div className="admin-login-field">
                    <label htmlFor="login-email" className="form-label">{t("ui.email.address")}</label>

                    <div className="login-input-box">
                      <svg className="login-input-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <rect x="3.5" y="5" width="17" height="14" rx="2" />
                        <path d="m5 7 7 5.5L19 7" />
                      </svg>
                      <input
                        id="login-email"
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder={text("Enter your registered email")}
                        value={form.email}
                        onChange={handleChange}
                        autoComplete="email"
                        required
                      />
                    </div>
                  </div>
                  <div className="admin-login-field">
                    <div className="admin-login-field-heading">
                      <label htmlFor="login-password" className="form-label">{t("ui.password")}</label>
                     
                    </div>
                    <div className="login-input-box">
                      <svg className="login-input-icon" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                        <rect x="5" y="10" width="14" height="11" rx="2" />
                        <path d="M8 10V7a4 4 0 1 1 8 0v3M12 14.5v2.5" />
                      </svg>
                      <input
                        id="login-password"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className="form-control"
                        placeholder={t("ui.enter.your.password")}
                        value={form.password}
                        onChange={handleChange}
                        autoComplete="current-password"
                        required
                      />

                      <button
                        type="button"
                        className="login-show-password"
                        onClick={() => setShowPassword((prev) => !prev)}
                        aria-label={
                          showPassword ? t("ui.hidePassword") : t("ui.showPassword")
                        }
                      >
                        {showPassword ? (
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <path
                              d="M3 3L21 21"
                              stroke="currentColor"
                              strokeWidth="1.7"
                              strokeLinecap="round"
                            />

                            <path
                              d="M10.58 10.58C10.21 10.95 10 11.45 10 12C10 13.1 10.9 14 12 14C12.55 14 13.05 13.79 13.42 13.42"
                              stroke="currentColor"
                              strokeWidth="1.7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />

                            <path
                              d="M9.88 5.08C10.56 4.93 11.27 4.85 12 4.85C16.45 4.85 19.67 7.43 21.3 12C20.75 13.54 20 14.84 19.06 15.88"
                              stroke="currentColor"
                              strokeWidth="1.7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />

                            <path
                              d="M6.61 6.61C4.82 7.77 3.5 9.57 2.7 12C4.33 16.57 7.55 19.15 12 19.15C13.47 19.15 14.8 18.87 15.97 18.34"
                              stroke="currentColor"
                              strokeWidth="1.7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            aria-hidden="true"
                          >
                            <path
                              d="M2.7 12C4.33 7.43 7.55 4.85 12 4.85C16.45 4.85 19.67 7.43 21.3 12C19.67 16.57 16.45 19.15 12 19.15C7.55 19.15 4.33 16.57 2.7 12Z"
                              stroke="currentColor"
                              strokeWidth="1.7"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />

                            <circle
                              cx="12"
                              cy="12"
                              r="2.6"
                              stroke="currentColor"
                              strokeWidth="1.7"
                            />
                          </svg>
                        )}
                      </button>
                    </div>
                  </div>

                  {/* OPTIONS */}

                  <div className="admin-login-options">
                    <label className="admin-login-remember">
                      <input
                        type="checkbox"
                        checked={rememberMe}
                        onChange={(e) => setRememberMe(e.target.checked)}
                      />
                      <span>{text("Keep me signed in")}</span>
                    </label>
                     <button
                        type="button"
                        className="admin-login-secure"
                        onClick={handleForgotPassword}
                      >
                        {t("ui.forgot.password.rtdrbb")}
                      </button>
                  </div>
                  <button
                    type="submit"
                    className="recent-view-all-btn w-100 login-submit-button"
                    disabled={!canSubmitLogin}
                  >
                    <span>
                      {vendorAuthLoading
                        ? t("ui.signingIn")
                        : t("ui.sign.in")}
                    </span>
                    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                      <path d="M4 12h15m-6-6 6 6-6 6" />
                    </svg>
                  </button>
                </form>
                <div className="admin-login-bottom-text">
                  <span>{text("Don't have an account?")}</span>
                  <button type="button" onClick={handleSignup}>
                    {text("Create a vendor account")}
                  </button>
                </div>
              </div>
            </div>
          </div>  
        </div>
      </div>
    </main>
  );
};

export default Login;
